<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<div class="main-page">

  <div class="main-visual">
    <swiper [config]="SwiperConfigInterface_main">
      <div class="img-wrapper img-wrapper1">
        <img class="pc-img" src="/assets/images/main_visual01.png" alt="main visual" />
        <img class="mobile-img" src="/assets/images/main_visualm01.png" alt="main visual" />
        <div>
            <p [ngClass]="{'txt1_ko':params.language=='ko', 'txt1_vi':params.language=='vi', 'txt1_en':params.language=='en', 'txt1_zh':params.language=='zh'}">{{'MAIN.TITLE1' | translate}}</p>
            <p [ngClass]="{'txt1_1_ko':params.language=='ko', 'txt1_1_vi':params.language=='vi', 'txt1_1_en':params.language=='en', 'txt1_1_zh':params.language=='zh'}">{{'MAIN.TITLE1_1' | translate}}</p>
        </div>
      </div>
      <div class="img-wrapper img-wrapper2">
        <img class="pc-img" src="/assets/images/main_visual02.png" alt="main visual" />
        <img class="mobile-img" src="/assets/images/main_visualm02.png" alt="main visual" />
        <div [ngClass]="{'txt2_ko':params.language=='ko', 'txt2_vi':params.language=='vi', 'txt2_en':params.language=='en', 'txt2_zh':params.language=='zh'}">{{'MAIN.TITLE2' | translate}}</div>
      </div>
      <div class="img-wrapper img-wrapper3">
        <img class="pc-img" src="/assets/images/main_visual03.png" alt="main visual" />
        <img class="mobile-img" src="/assets/images/main_visualm03.png" alt="main visual" />        
        <div [ngClass]="{'txt3_ko':params.language=='ko', 'txt3_vi':params.language=='vi', 'txt3_en':params.language=='en', 'txt3_zh':params.language=='zh'}">{{'MAIN.TITLE3' | translate}}</div>
      </div>
    </swiper>
    <div class="swiper-button swiper-button-next1"></div>
    <div class="swiper-button swiper-button-prev1"></div>
  </div>

  <div class="customer-center">
    <div class="contact">
      <div class="center-title">Customer Center</div>
      <div class="tel">(82) 41-587-9809</div>
      <div class="tel1">
        <div><span>fax.</span>(82) 41-587-9808</div>
        <div><span>e-mail.</span>century@century-korea.com</div>
      </div>
    </div>
    <div class="q-link">
<!--      <a routerLink="" class="quick-link quick-link1">{{'MAIN.ICON1' | translate}}</a> -->
      <a class="quick-link quick-link1" href="/assets/catalog.pdf">{{'MAIN.ICON1' | translate}}</a>
      <a routerLink="/contents" [queryParams]="{menu_seq:466}" class="quick-link quick-link2">{{'MAIN.ICON2' | translate}}</a>
    </div>
    <a routerLink="/board/list" [queryParams]="{board_id:'online'}" class="online-estimate" [innerHTML]="'MAIN.ONLINE' | translate"></a>
  </div>

  <div class="goods-info">
    <div class="inner-wrap">
      <div class="section-title">{{'MAIN.PRODUCT_TITLE' | translate}}</div>
      <div class="goods-wrap">
        <ul class="clearfix">
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:474}">
              <div class="img"><img src="/assets/images/OilFreeChiller.png" [alt]="'MAIN.PRODUCT5_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT5_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT5_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:469}">
              <div class="img"><img src="/assets/images/centrifugalWaterChiller.png" [alt]="'MAIN.PRODUCT1_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT1_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT1_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:470}">
              <div class="img"><img src="/assets/images/screwWaterChiller.png" [alt]="'MAIN.PRODUCT2_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT2_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT2_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:471}">
              <div class="img"><img src="/assets/images/scrollChiller.png" [alt]="'MAIN.PRODUCT3_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT3_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT3_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:472}">
              <div class="img"><img src="/assets/images/ahu.png" [alt]="'MAIN.PRODUCT4_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT4_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT4_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:475}">
              <div class="img"><img src="/assets/images/cth.png" [alt]="'MAIN.PRODUCT6_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT6_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT6_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:476}">
              <div class="img"><img src="/assets/images/inverterAirConditioner.png" [alt]="'MAIN.PRODUCT7_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT7_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT7_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:477}">
              <div class="img"><img src="/assets/images/coolingTower.png" [alt]="'MAIN.PRODUCT8_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT8_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT8_MSG' | translate}}</div>
            </a>
          </li>
          <!-- <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:480}">
              <div class="img"><img src="/assets/images/goods09.png" [alt]="'MAIN.PRODUCT9_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT9_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT9_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:482}">
              <div class="img"><img src="/assets/images/goods10.png" [alt]="'MAIN.PRODUCT9_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT10_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT10_MSG' | translate}}</div>
            </a>
          </li> -->
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:491}">
              <div class="img"><img src="/assets/images/goods11.png" [alt]="'MAIN.PRODUCT11_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT11_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT11_MSG' | translate}}</div>
            </a>
          </li>
          <li>
            <a routerLink="/contents" [queryParams]="{menu_seq:492}">
              <div class="img"><img src="/assets/images/goods12.png" [alt]="'MAIN.PRODUCT12_NAME' | translate"></div>
              <div class="goods-name">{{'MAIN.PRODUCT12_NAME' | translate}}</div>
              <div class="line"><span></span></div>
              <div class="goods-txt">{{'MAIN.PRODUCT12_MSG' | translate}}</div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="certification">
    <div class="inner-wrap">
      <div class="certification-title">{{'MAIN.CERT_TITLE' | translate}}</div>
      <div class="certification-list">
        <swiper [config]=swiperCertification>
          <div class="cert-wrapper">
            <div>
              <div><a routerLink="/contents" [queryParams]="{menu_seq:464}" fragment="iso9001">{{'MAIN.CERT_ISO9001' | translate}}</a></div>
              <div><a routerLink="/contents" [queryParams]="{menu_seq:464}" fragment="iso14001">{{'MAIN.CERT_ISO14001' | translate}}</a></div>
            </div>
          </div>
          <div class="cert-wrapper">
            <div>
              <div><a routerLink="/contents" [queryParams]="{menu_seq:464}" fragment="iso45001">{{'MAIN.CERT_ISO45001' | translate}}</a></div>
              <div><a routerLink="/contents" [queryParams]="{menu_seq:464}" fragment="list2">{{'MAIN.CERTIFICATE' | translate}}</a></div>
            </div>
          </div>
        </swiper>
      </div>
      <a routerLink="/contents" [queryParams]="{menu_seq:464}" class="more">{{'MAIN.MORE' | translate}}</a>
    </div>
  </div>

  <div class="as inner-wrap clearfix">
    <div class="section-title">{{'MAIN.AS_TITLE' | translate}}</div>
    <div class="as-list">
      <div class="as-img">
        <swiper [config]=swiperAs [(index)]="asIndex">
          <div class="as-wrapper" *ngFor="let item of maintenanceList">
            <a routerLink="/board/view" [queryParams]="{board_id: 'maintenance', board_seq: item.seq}">
              <div class="img">
                <img [src]="item.upload_file" alt="{{item.subject}}" />
              </div>
              <div class="text">
                <div class="title">{{item.subject}}</div>
                <div class="txt"></div>
              </div>
            </a>
          </div>
        </swiper>
      </div>
      <!-- <a routerLink="/board/view" class="as-detail">자세히 보기</a> -->
      <ul class="as-pagination">
        <li *ngFor="let item of maintenanceList; let i = index" [ngClass]="{active: asIndex==i}" (mouseover)="asIndex=i">{{( i < 10 ? '0' : '' ) + ( i + 1 )}}</li>
      </ul>
    </div>
    <div class="as-mobile"></div>
    <div class="as-mobile1"></div>
    <a routerLink="/board/list" [queryParams]="{board_id: 'maintenance'}" class="as-more">{{'MAIN.AS_MORE' | translate}}</a>
  </div>

</div>

<app-footer></app-footer>